import { Component, Injector, OnInit, OnDestroy } from '@angular/core';
import { Breadcrumb } from '../services/breadcrumb';
import { SupportContact } from '../services/support-contact';

@Component({
  template: '',
})
export class BaseUpgradeComponent implements OnInit, OnDestroy {
  public breadcrumb;
  public supportContact;

  constructor(public injector: Injector) {
    this.injector = injector;
    this.breadcrumb = injector.get(Breadcrumb);
    this.supportContact = injector.get(SupportContact);
  }

  public ngOnInit(): void {
    this._initBreadcrumb();
  }

  public ngOnDestroy() {
    this.breadcrumb.clear();
  }

  protected _initBreadcrumb() { console.error('Implement _initBreadcrumb() in child class'); }
}
